<template>
  <v-menu
    transition="slide-x-transition"
    left
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        dark
      >
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-if="permissions.scheduler.actions.view"
        @click="goTo_(value, 'view')"
        link
      >
        <v-list-item-icon>
          <v-icon>mdi-eye-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ lang.scheduler.actions.view }}
        </v-list-item-title>
      </v-list-item>
      <!-- <v-list-item
        v-if="permissions.scheduler.actions.edit"
        @click="hold_(value)"
        link
      >
        <v-list-item-icon>
          <v-icon>mdi-calendar-clock</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ lang.scheduler.actions.hold }}
        </v-list-item-title>
      </v-list-item> -->
      <v-list-item
        v-if="permissions.scheduler.actions.edit"
        @click="cancel_(value)"
        link
      >
        <v-list-item-icon>
          <v-icon>mdi-cancel</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ lang.scheduler.actions.cancel }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="permissions.scheduler.actions.edit"
        @click="goTo_(value, 'edit')"
        link
      >
        <v-list-item-icon>
          <v-icon>mdi-calendar-edit</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ lang.scheduler.actions.edit }}
        </v-list-item-title>
      </v-list-item>
      <!-- <v-list-item
        v-if="permissions.scheduler.actions.edit"
        @click="status_(value)"
        link
      >
        <v-list-item-icon>
          <v-icon>mdi-list-status</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ lang.scheduler.actions.status }}
        </v-list-item-title>
      </v-list-item> -->
      <v-list-item
        v-if="permissions.scheduler.actions.edit"
        @click="delete_(value)"
        link
      >
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ lang.scheduler.actions.delete }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import appdata from '@/mixins/appdata'
import scheduler from '../mixins/index'

export default {
  mixins: [ appdata, scheduler ],
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>

</style>